import React from 'react'
import TrendingKeywords from './TrendingKeywords'

interface TrendingKeywordsContainerProps {
  trendingKeywords?: string[]
  keywordOnClick?: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void
}

function TrendingKeywordsContainer(props: TrendingKeywordsContainerProps) {
  const { trendingKeywords, keywordOnClick } = props
  return <TrendingKeywords data={trendingKeywords} keywordOnClick={keywordOnClick} />
}

export default TrendingKeywordsContainer
